import type { IWidget } from '@/interfaces/components/dashboard/widget'
import { useCompanyDashboardStore } from '@/store/companyDashboard'
import { storeToRefs } from 'pinia'

export function useTotalizerWidget() {
  const store = useCompanyDashboardStore()
  const { totalizerWidgetStates } = storeToRefs(store)

  const getState = (widget: IWidget) => {
    return (
      totalizerWidgetStates.value[widget.id] ?? {
        demand: null,
        consumption: null,
        utilization: null,
        mixing_cycle: null,
        loading: false,
        error: true,
      }
    )
  }

  const isLoading = (widget: IWidget): boolean => {
    return getState(widget).loading
  }

  const hasError = (widget: IWidget): boolean => {
    return getState(widget).error
  }

  return { getState, isLoading, hasError }
}
